export default "__VITE_ASSET__8eb606e3__"